import {
  isUnknownDomain
} from '../api/validators/proposal';
const getAttendeeName = (att = {}) => {
  if (isUnknownDomain(att.email)) return att.label;
  return att.email
}
export default getAttendeeName;